module.exports = __webpack_public_path__ + "static/media/edinburgh-7.bd312304.jpg";